module.exports = __webpack_public_path__ + "img/new-student-guide-qr.e28cebec.png";